import { queryOptions } from '@tanstack/react-query'
import { companyRequest } from '@/shared/api'
import { ProjectListSchema, ProjectResponseSchema } from '../model/types'

export const projectKeys = {
  all: ['project'] as const,
  list: (q: string, archived: boolean, companyId: string) =>
    ['project', 'list', q, archived, companyId] as const,
  detail: (id: string) => ['project', 'detail', id] as const,
}

export interface ProjectsFilter {
  q?: string
  archived?: boolean
  companyId?: string
}

export function projectsQueryOptions({
  q = '',
  archived = false,
  companyId = '',
}: ProjectsFilter = {}) {
  return queryOptions({
    queryKey: projectKeys.list(q, archived, companyId),
    queryFn: async () => {
      // Wire: только company_id + include_archived; текстового фильтра у бэкенда
      // нет — q применяется на клиенте.
      const body = await companyRequest<unknown>({
        method: 'GET',
        path: '/projects',
        query: { company_id: companyId || undefined, include_archived: archived },
      })
      const items = ProjectListSchema.parse(body).data ?? []
      const needle = q.trim().toLowerCase()
      if (!needle) return items
      return items.filter((p) => p.name.toLowerCase().includes(needle))
    },
  })
}

export function projectQueryOptions(id: string) {
  return queryOptions({
    queryKey: projectKeys.detail(id),
    queryFn: async () => {
      const body = await companyRequest<unknown>({ method: 'GET', path: `/projects/${id}` })
      return ProjectResponseSchema.parse(body).data
    },
  })
}
